import WorkOrderSupplySubContract from '@/models/WorkOrderSupplySubContract/WorkOrderSupplySubContract';

export default class WorkOrderSupplySubContractFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.materialIssueNumber = '';
		this.purchaseOrderId  = '';
		this.purchaseOrderPurchaseOrderNumber = '';
		this.materialIssueDateFrom = '';
		this.materialIssueDateTo = '';
		this.revisi = '';
		this.wosSubcontStatusId  = '';
		this.wosSubcontStatusName = '';
		this.wosSubcontStatusCode = '';
		this.vendorId  = '';
		this.vendorCode = '';
		this.remarksMultiple = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			materialIssueNumber : '0',
			purchaseOrderId : '0',
			purchaseOrderPurchaseOrderNumber : '0',
			materialIssueDateFrom : '0',
			materialIssueDateTo : '0',
			revisi : '0',
			wosSubcontStatusId : '0',
			wosSubcontStatusName : '0',
			wosSubcontStatusCode : '0',
			vendorId : '0',
			vendorCode : '0',
			remarksMultiple : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}